import { render, staticRenderFns } from "./RecommendationSection.vue?vue&type=template&id=024c9fd2&"
import script from "./RecommendationSection.vue?vue&type=script&lang=js&"
export * from "./RecommendationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports